import React, { useEffect, useState, useCallback } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

import VerifiedIcon from "@mui/icons-material/Verified";
import Dropdown from "react-bootstrap/Dropdown";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Avatar,
  Box,
  Divider,
  Stack,
} from "@mui/material";
import NavBar from "../../structure/NavBar";
import { NavBarTop } from "../../structure/NavBarTop";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateTopHeader,
  updateLoading,
} from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import Utils from "../../constants/Utils";
import { FullImageView } from "../../custom/FullImageView";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import useMerchantEdit from "./useMerchantEdit";
const statusMenu = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Approve",
    value: "APPROVED",
  },
  {
    label: "Reject",
    value: "REJECTED",
  },
];
const ViewBusinessDetails = () => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [reasonError, setReasonError] = useState(false);
  const [statusDropdownText, setStatusDropdownText] = useState({
    label: "Pending",
    value: "PENDING",
  });
  const [imageUrl, setImageUrl] = useState(false);
  const [fullSizePreview, setFullSizePreview] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const { formatDate } = Utils();
  const { id } = useParams();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.userData);
  const [merchantDetailsData, setMerchantDetailsData] = useState({});
  const [userDetailsData, setUserDetailsData] = useState({});
  const [businessCategoriesMap, setBusinessCategoriesMap] = useState(new Map());
  const [availableCategories, setAvailableCategories] = useState([]);

  const getMerchantGuarantorDetails = useCallback(
    async (agentCode, guarantorNumber, merchantReelId) => {
      try {
        dispatch(updateLoading(true));
        let path =
          urls.getAgentGuarantorDetails +
          "?agentCode=" +
          agentCode +
          "&guarantorNumber=" +
          guarantorNumber +
          "&merchantReelId=" +
          merchantReelId;
        let res = await ApiCaller.get({}, path, userData?.access_token);
        const response = await res.response.json();
        if (response.status === 200 || response.status === "200") {
          dispatch(updateLoading(false));
          console.log(response?.data);
        } else {
          dispatch(updateLoading(false));
          showDangerToast(response.message);
        }
      } catch (error) {
        dispatch(updateLoading(false));
        console.error(error);
        showDangerToast(error.message);
      }
    },
    [dispatch, userData?.access_token]
  );
  const getBusinessCategories = useCallback(
    async (categoryIds) => {
      try {
        dispatch(updateLoading(true));
        let path = urls.getCategoyByIds;
        // Send categoryIds array directly as the backend expects List<String>
        let res = await ApiCaller.post(
          categoryIds,
          path,
          userData?.access_token
        );
        const response = await res.response.json();
        if (response.status === 200 || response.status === "200") {
          dispatch(updateLoading(false));
          return response?.data; // Return the data so it can be used
        } else {
          dispatch(updateLoading(false));
          showDangerToast(response.message);
          return null;
        }
      } catch (error) {
        dispatch(updateLoading(false));
        console.error(error);
        showDangerToast(error.message);
        return null;
      }
    },
    [dispatch, userData?.access_token]
  );

  const getAllBusinessCategories = useCallback(async () => {
    try {
      let path = urls.businessCategoryList;
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === "200") {
        setAvailableCategories(response?.data || []);
      } else {
        console.error("Failed to fetch categories:", response.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, [userData?.access_token]);

  const getUserDetails = useCallback(
    async (userId) => {
      try {
        dispatch(updateLoading(true));
        let path = urls.userDetails + "/" + userId;
        let res = await ApiCaller.get({}, path, userData?.access_token);
        const response = await res.response.json();
        if (response.status === 200 || response.status === "200") {
          dispatch(updateLoading(false));
          setUserDetailsData(response?.data);
        } else {
          dispatch(updateLoading(false));
          showDangerToast(response.message);
        }
      } catch (error) {
        dispatch(updateLoading(false));
        console.error(error);
        showDangerToast(error.message);
      }
    },
    [dispatch, userData?.access_token]
  );

  // Helper function to get category names for a business
  const getCategoryNamesForBusiness = useCallback(
    (businessId) => {
      const categories = businessCategoriesMap.get(businessId);
      if (categories && categories.length > 0) {
        return categories.map((cat) => cat.categoryName || cat.name).join(", ");
      }
      return "-";
    },
    [businessCategoriesMap]
  );

  const getMerchantBusinessDetails = useCallback(async () => {
    try {
      dispatch(updateLoading(true));
      let path = urls.businessMerchantDetails + "/" + id;
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === "200") {
        dispatch(updateLoading(false));
        setMerchantDetailsData(response?.data);
        getUserDetails(response?.data?.reelId);
        await getMerchantGuarantorDetails(
          response?.data?.agentCode,
          response?.data?.guarantorNumber,
          response?.data?.reelId
        );

        // Get business categories for each business in the list
        if (response?.data?.merchantBusinessDetailsList?.length > 0) {
          const categoriesMap = new Map();
          for (let business of response?.data?.merchantBusinessDetailsList) {
            if (business?.businessCategory?.length > 0) {
              const categories = await getBusinessCategories(
                business.businessCategory
              );
              if (categories) {
                categoriesMap.set(business.merchantBusinessId, categories);
              }
            }
          }
          setBusinessCategoriesMap(categoriesMap);
        }

        if (response?.data?.status) {
          if (response?.data?.status === "PENDING") {
            setStatusDropdownText({
              label: "Pending",
              value: "PENDING",
            });
          } else if (response?.data?.status === "APPROVED") {
            setStatusDropdownText({
              label: "Approve",
              value: "APPROVED",
            });
          } else if (response?.data?.status === "REJECTED") {
            setStatusDropdownText({
              label: "Reject",
              value: "REJECTED",
            });
          }
        }
        // setDisplayAddress(getAddressFromLatLng(response?.data?.lat, response?.data?.lng))
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  }, [
    dispatch,
    id,
    userData?.access_token,
    getBusinessCategories,
    getMerchantGuarantorDetails,
    getUserDetails,
  ]);

  // Use custom hook for merchant edit functionality
  const {
    isEditMode,
    editFormData,
    selectedFiles,
    filePreviews,
    handleEditClick,
    handleCancelEdit,
    handleSaveEdit,
    handleFormFieldChange,
    handleFileInputChange,
    clearFileSelection
  } = useMerchantEdit(id, merchantDetailsData, getMerchantBusinessDetails);

  const updateStatus = useCallback(async () => {
    // If status is REJECTED, require a reason
    if (statusDropdownText?.value === "REJECTED" && !rejectionReason.trim()) {
      setReasonError(true);
      showDangerToast("Please enter a reason for rejection.");
      return;
    }
    setReasonError(false);
    try {
      dispatch(updateLoading(true));
      let path = urls.changeBusinessMerchantStatus + "/" + id;
      let postJSon = {
        status: statusDropdownText?.value,
        reason: statusDropdownText?.value === "REJECTED" ? rejectionReason : "",
      };
      let res = await ApiCaller.put(postJSon, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === "200") {
        dispatch(updateLoading(false));
        getMerchantBusinessDetails(response?.data);
        showToast(response.message);
        setRejectionReason(""); // Clear reason after update
        setShowRejectModal(false);
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  }, [
    statusDropdownText?.value,
    rejectionReason,
    dispatch,
    id,
    userData?.access_token,
    getMerchantBusinessDetails,
  ]);

  const handleChangeStatus = useCallback(async () => {
    if (statusDropdownText?.value === "REJECTED") {
      setShowRejectModal(true);
      return;
    }
    // For APPROVED or PENDING
    await updateStatus();
  }, [statusDropdownText?.value, updateStatus]);



  useEffect(() => {
    dispatch(updateTopHeader("Business Details Manager"));
    if (id) {
      getMerchantBusinessDetails();
    }
    getAllBusinessCategories();
  }, [id, dispatch, getMerchantBusinessDetails, getAllBusinessCategories]);

  return (
    <>
      <NavBar />
      <div
        className="main-content"
        style={{ background: "#f5f6fa", minHeight: "100vh" }}
      >
        <NavBarTop />
        <Box sx={{ p: { xs: 1, md: 3 } }} style={{ paddingTop: "85px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Card
                sx={{
                  mb: 2,
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    gutterBottom
                    color="primary"
                  >
                    Merchant Overview
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Username
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.userName || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          User ID
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.chatUserId || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Full Name
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.fullName || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Email
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.email || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Mobile
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.ext}{" "}
                          {userDetailsData?.contactNumber || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Gender
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.gender || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Date Of Birth
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.dob || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Registration Date
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {formatDate(userDetailsData?.createdAt) || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Exclusive Enable
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.exclusiveEnable ? (
                            <Chip
                              label="Enabled"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <Chip
                              label="Disabled"
                              color="default"
                              size="small"
                            />
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Account Type
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.accountType || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Register Via
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.signInType || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Total Chips
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.totalChipsBalance || "0"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          p: 2,
                          bgcolor: "#f8f9fa",
                          borderRadius: 2,
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ mb: 0.5 }}
                        >
                          Categories
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                          {userDetailsData?.userPreferredTags?.join(", ") ||
                            "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{ p: 2 }}
                  >
                    <Avatar
                      src={userDetailsData?.profilePic}
                      alt={userDetailsData?.fullName}
                      sx={{
                        width: 120,
                        height: 120,
                        mb: 2,
                        cursor: "pointer",
                        border: "3px solid #e3f2fd",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                        },
                      }}
                      onClick={() => {
                        setFullSizePreview(!fullSizePreview);
                        setImageUrl(userDetailsData?.profilePic);
                      }}
                    />
                    {userDetailsData?.isBadged && (
                      <Box sx={{ position: "relative", mb: 1 }}>
                        <VerifiedIcon color="primary" sx={{ fontSize: 30 }} />
                      </Box>
                    )}
                    <Typography
                      variant="h5"
                      fontWeight={700}
                      textAlign="center"
                      sx={{ mb: 1 }}
                    >
                      {userDetailsData?.fullName || "-"}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="primary"
                      fontWeight={500}
                      sx={{ mb: 1 }}
                    >
                      @{userDetailsData?.userName || "-"}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      textAlign="center"
                      sx={{ mb: 3, maxWidth: "100%" }}
                    >
                      {userDetailsData?.bio || "No bio available"}
                    </Typography>
                    <Divider sx={{ width: "100%", mb: 3 }} />

                    {/* Stats Section */}
                    <Grid container spacing={2} justifyContent="center">
                      <Grid item xs={6}>
                        <Box
                          textAlign="center"
                          sx={{ p: 2, bgcolor: "#f8f9fa", borderRadius: 2 }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight={700}
                            color="primary"
                          >
                            {userDetailsData?.totalFollowers || "0"}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Followers
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box
                          textAlign="center"
                          sx={{ p: 2, bgcolor: "#f8f9fa", borderRadius: 2 }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight={700}
                            color="primary"
                          >
                            {userDetailsData?.totalFollowing || "0"}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Following
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box
                          textAlign="center"
                          sx={{ p: 2, bgcolor: "#f8f9fa", borderRadius: 2 }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight={700}
                            color="primary"
                          >
                            {userDetailsData?.totalVideos || "0"}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Videos
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box
                          textAlign="center"
                          sx={{ p: 2, bgcolor: "#f8f9fa", borderRadius: 2 }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight={700}
                            color="primary"
                          >
                            {userDetailsData?.totalLikes || "0"}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Likes
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Merchant Application Overview */}
          <Card
            sx={{
              mb: 3,
              borderRadius: 3,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                background: "linear-gradient(135deg, #2196f3 0%, #21cbf3 100%)",
                color: "white",
                p: 3,
              }}
            >
              <Grid container alignItems="center" justifyContent="space-between">
                <Grid item>
                  <Typography variant="h5" fontWeight={700} gutterBottom>
                    Merchant Application Overview
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Application ID: {merchantDetailsData?.merchantUserId || "N/A"}
                  </Typography>
                </Grid>
                <Grid item>
                  {!isEditMode ? (
                    <Button
                      variant="contained"
                      startIcon={<EditIcon />}
                      onClick={handleEditClick}
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "white",
                        border: "1px solid rgba(255,255,255,0.3)",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                        },
                      }}
                    >
                      Edit
                    </Button>
                  ) : (
                    <Stack direction="row" spacing={1}>
                      <Button
                        variant="contained"
                        startIcon={<CancelIcon />}
                        onClick={handleCancelEdit}
                        sx={{
                          bgcolor: "rgba(244,67,54,0.8)",
                          color: "white",
                          "&:hover": {
                            bgcolor: "rgba(244,67,54,1)",
                          },
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={handleSaveEdit}
                        sx={{
                          bgcolor: "rgba(76,175,80,0.8)",
                          color: "white",
                          "&:hover": {
                            bgcolor: "rgba(76,175,80,1)",
                          },
                        }}
                      >
                        Save
                      </Button>
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </Box>
            <CardContent sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#e3f2fd",
                      borderRadius: 2,
                      border: "1px solid #2196f3",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ mb: 0.5 }}
                    >
                      Merchant User ID
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={500}
                      sx={{ fontSize: "0.8rem", wordBreak: "break-all" }}
                    >
                      {merchantDetailsData?.merchantUserId || "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#e8f5e8",
                      borderRadius: 2,
                      border: "1px solid #4caf50",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ mb: 0.5 }}
                    >
                      Reel ID
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={500}
                      sx={{ fontSize: "0.8rem", wordBreak: "break-all" }}
                    >
                      {merchantDetailsData?.reelId || "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#fff3e0",
                      borderRadius: 2,
                      border: "1px solid #ff9800",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ mb: 0.5 }}
                    >
                      Agent Code
                    </Typography>
                    {!isEditMode ? (
                      <Typography variant="body1" fontWeight={500}>
                        {merchantDetailsData?.agentCode || "Not Assigned"}
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        value={editFormData.agentCode}
                        onChange={(e) => handleFormFieldChange('agentCode', e.target.value)}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                              borderWidth: '1.5px'
                            },
                            '&:hover fieldset': {
                              borderColor: '#2196f3',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#2196f3',
                              borderWidth: '2px'
                            }
                          },
                          '& .MuiInputBase-input': {
                            padding: '10px 14px',
                            fontWeight: '500',
                            fontSize: '14px'
                          }
                        }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#fce4ec",
                      borderRadius: 2,
                      border: "1px solid #e91e63",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ mb: 0.5 }}
                    >
                      Guarantor Number
                    </Typography>
                    {!isEditMode ? (
                      <Typography variant="body1" fontWeight={500}>
                        {merchantDetailsData?.guarantorNumber || "Not Assigned"}
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        value={editFormData.guarantorNumber}
                        onChange={(e) => handleFormFieldChange('guarantorNumber', e.target.value)}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            fontSize: '14px',
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                              borderWidth: '1.5px'
                            },
                            '&:hover fieldset': {
                              borderColor: '#2196f3',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#2196f3',
                              borderWidth: '2px'
                            }
                          },
                          '& .MuiInputBase-input': {
                            padding: '10px 14px',
                            fontWeight: '500',
                            fontSize: '14px'
                          }
                        }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#f3e5f5",
                      borderRadius: 2,
                      border: "1px solid #9c27b0",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ mb: 0.5 }}
                    >
                      Application Status
                    </Typography>
                    <Chip
                      label={merchantDetailsData?.status || "PENDING"}
                      sx={{
                        bgcolor:
                          merchantDetailsData?.status === "APPROVED"
                            ? "#4caf50"
                            : merchantDetailsData?.status === "REJECTED"
                            ? "#f44336"
                            : "#ff9800",
                        color: "white",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        px: 2,
                        py: 1,
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Business Applications Section */}

          {merchantDetailsData?.merchantBusinessDetailsList?.map(
            (biz, index) => (
              <Card
                key={index}
                sx={{
                  mb: 3,
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  overflow: "hidden",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  {/* Header Section */}
                  <Box
                    sx={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "white",
                      p: 3,
                    }}
                  >
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                            {biz.businessName || `Business ${index + 1}`}
                          </Typography>
                        <Chip
                          label={merchantDetailsData?.status || "PENDING"}
                          sx={{
                            bgcolor:
                              merchantDetailsData?.status === "APPROVED"
                                ? "#4caf50"
                                : merchantDetailsData?.status === "REJECTED"
                                ? "#f44336"
                                : "#ff9800",
                            color: "white",
                            fontWeight: 600,
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              style={{
                                backgroundColor: "rgba(255,255,255,0.2)",
                                color: "white",
                                border: "1px solid rgba(255,255,255,0.3)",
                                boxShadow: "none",
                                transform: "none",
                                minWidth: 120,
                                backdropFilter: "blur(10px)",
                              }}
                              id="dropdown-basic"
                            >
                              {statusDropdownText?.label}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {statusMenu?.map((menuItem) => (
                                <Dropdown.Item
                                  key={menuItem.value}
                                  onClick={() =>
                                    setStatusDropdownText(menuItem)
                                  }
                                >
                                  {menuItem?.label}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                          <Button
                            variant="contained"
                            sx={{
                              minWidth: 100,
                              bgcolor: "rgba(255,255,255,0.2)",
                              color: "white",
                              border: "1px solid rgba(255,255,255,0.3)",
                              "&:hover": {
                                bgcolor: "rgba(255,255,255,0.3)",
                              },
                            }}
                            onClick={handleChangeStatus}
                          >
                            Update
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* Business Details Section */}
                  <Box sx={{ p: 3 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={8}>
                        <Stack spacing={2}>
                          <Box>
                            <Typography
                              variant="h6"
                              color="primary"
                              fontWeight={600}
                              gutterBottom
                            >
                              Contact Information
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Business Email
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.businessEmail || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      type="email"
                                      value={editFormData.businessEmail}
                                      onChange={(e) => handleFormFieldChange('businessEmail', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '10px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Business Mobile
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.businessMobile || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={editFormData.businessMobile}
                                      onChange={(e) => handleFormFieldChange('businessMobile', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '10px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>

                          <Box>
                            <Typography
                              variant="h6"
                              color="primary"
                              fontWeight={600}
                              gutterBottom
                            >
                              Business Information
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Business Name
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.businessName || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={editFormData.businessName}
                                      onChange={(e) => handleFormFieldChange('businessName', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '10px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    License Number
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.licenceNumber || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={editFormData.licenceNumber}
                                      onChange={(e) => handleFormFieldChange('licenceNumber', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '10px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Business ID
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    sx={{ fontSize: "0.85rem" }}
                                  >
                                    {biz.merchantBusinessId || "-"}
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Latitude
                                  </Typography>
                                  <Typography variant="body1" fontWeight={500}>
                                    {biz.lat || "-"}
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Longitude
                                  </Typography>
                                  <Typography variant="body1" fontWeight={500}>
                                    {biz.lng || "-"}
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Business Categories
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {getCategoryNamesForBusiness(
                                        biz.merchantBusinessId
                                      )}
                                    </Typography>
                                  ) : (
                                    <Autocomplete
                                      multiple
                                      size="small"
                                      options={availableCategories}
                                      getOptionLabel={(option) => option.categoryName || option.name || ""}
                                      value={availableCategories.filter(cat => editFormData.businessCategory.includes(cat.id || cat._id))}
                                      onChange={(event, newValue) => {
                                        const categoryIds = newValue.map(cat => cat.id || cat._id);
                                        handleFormFieldChange('businessCategory', categoryIds);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select categories"
                                          variant="outlined"
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              backgroundColor: 'white',
                                              borderRadius: '8px',
                                              fontSize: '14px',
                                              '& fieldset': {
                                                borderColor: '#e0e0e0',
                                                borderWidth: '1.5px'
                                              },
                                              '&:hover fieldset': {
                                                borderColor: '#2196f3',
                                              },
                                              '&.Mui-focused fieldset': {
                                                borderColor: '#2196f3',
                                                borderWidth: '2px'
                                              }
                                            },
                                            '& .MuiInputBase-input': {
                                              padding: '10px 14px',
                                              fontWeight: '500',
                                              fontSize: '14px'
                                            }
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Address
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.displayAddress || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      multiline
                                      rows={3}
                                      value={editFormData.displayAddress}
                                      onChange={(e) => handleFormFieldChange('displayAddress', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '12px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px',
                                          lineHeight: '1.4'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#f8f9fa",
                                    borderRadius: 2,
                                    border: "1px solid #e9ecef",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 0.5 }}
                                  >
                                    Description
                                  </Typography>
                                  {!isEditMode ? (
                                    <Typography variant="body1" fontWeight={500}>
                                      {biz.description || "-"}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      fullWidth
                                      size="small"
                                      multiline
                                      rows={4}
                                      value={editFormData.description}
                                      onChange={(e) => handleFormFieldChange('description', e.target.value)}
                                      variant="outlined"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          fontSize: '14px',
                                          '& fieldset': {
                                            borderColor: '#e0e0e0',
                                            borderWidth: '1.5px'
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#2196f3',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#2196f3',
                                            borderWidth: '2px'
                                          }
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '12px 14px',
                                          fontWeight: '500',
                                          fontSize: '14px',
                                          lineHeight: '1.4'
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>

                          {/* Additional Business Assets */}
                          <Box>
                            <Typography
                              variant="h6"
                              color="primary"
                              fontWeight={600}
                              gutterBottom
                            >
                              Additional Assets
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#fff3e0",
                                    borderRadius: 2,
                                    border: "1px solid #ffcc02",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 1 }}
                                  >
                                    Live Selfie
                                  </Typography>
                                  {!isEditMode ? (
                                    biz.liveSelfie ? (
                                      <Box
                                        sx={{
                                          cursor: "pointer",
                                          transition: "all 0.3s ease",
                                          "&:hover": {
                                            transform: "scale(1.02)",
                                          },
                                        }}
                                        onClick={() => {
                                          setFullSizePreview(!fullSizePreview);
                                          setImageUrl(biz?.liveSelfie);
                                        }}
                                      >
                                        <img
                                          src={biz.liveSelfie}
                                          alt="Live Selfie"
                                          style={{
                                            width: "100%",
                                            height: 100,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                          }}
                                        />
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: 100,
                                          bgcolor: "#f5f5f5",
                                          borderRadius: 2,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "#aaa",
                                          border: "1px dashed #ccc",
                                        }}
                                      >
                                        Not Available
                                      </Box>
                                    )
                                  ) : (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Live Selfie URL"
                                        value={editFormData.liveSelfie}
                                        onChange={(e) => handleFormFieldChange('liveSelfie', e.target.value)}
                                        variant="outlined"
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            '& fieldset': {
                                              borderColor: '#e0e0e0',
                                              borderWidth: '1.5px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: '#2196f3',
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: '#2196f3',
                                              borderWidth: '2px'
                                            }
                                          },
                                          '& .MuiInputBase-input': {
                                            padding: '10px 14px',
                                            fontWeight: '500',
                                            fontSize: '14px'
                                          }
                                        }}
                                      />
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="body2" color="text.secondary">
                                          OR
                                        </Typography>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          style={{ display: 'none' }}
                                          id={`liveSelfie-upload`}
                                          onChange={(e) => handleFileInputChange(e, 'liveSelfie')}
                                        />
                                        <label htmlFor={`liveSelfie-upload`}>
                                          <Button
                                            component="span"
                                            variant="outlined"
                                            size="small"
                                            startIcon={<CloudUploadIcon />}
                                            sx={{ minWidth: 100 }}
                                          >
                                            Select File
                                          </Button>
                                        </label>
                                        {(editFormData.liveSelfie || selectedFiles.liveSelfie) && (
                                          <IconButton
                                            size="small"
                                            onClick={() => clearFileSelection('liveSelfie')}
                                            sx={{ color: 'error.main' }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </Box>
                                      {(editFormData.liveSelfie || filePreviews.liveSelfie) && (
                                        <img
                                          src={filePreviews.liveSelfie || editFormData.liveSelfie}
                                          alt="Selfie Preview"
                                          style={{
                                            width: "100%",
                                            height: 80,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #ddd",
                                          }}
                                          onError={(e) => {
                                            e.target.style.display = "none";
                                          }}
                                        />
                                      )}
                                      {selectedFiles.liveSelfie && (
                                        <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
                                          Selected: {selectedFiles.liveSelfie.name} (Will upload on save)
                                        </Typography>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    p: 2,
                                    bgcolor: "#e8f5e8",
                                    borderRadius: 2,
                                    border: "1px solid #4caf50",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ mb: 1 }}
                                  >
                                    Live Intro Video
                                  </Typography>
                                  {!isEditMode ? (
                                    biz.liveIntroVideo ? (
                                      <Box
                                        sx={{
                                          cursor: "pointer",
                                          transition: "all 0.3s ease",
                                          "&:hover": {
                                            transform: "scale(1.02)",
                                          },
                                        }}
                                        onClick={() => {
                                          setFullSizePreview(!fullSizePreview);
                                          setImageUrl(biz?.liveIntroVideo);
                                        }}
                                      >
                                        <video
                                          src={biz.liveIntroVideo}
                                          style={{
                                            width: "100%",
                                            height: 100,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                          }}
                                          controls={false}
                                          muted
                                        />
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: 100,
                                          bgcolor: "#f5f5f5",
                                          borderRadius: 2,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "#aaa",
                                          border: "1px dashed #ccc",
                                        }}
                                      >
                                        Not Available
                                      </Box>
                                    )
                                  ) : (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Live Intro Video URL"
                                        value={editFormData.liveIntroVideo}
                                        onChange={(e) => handleFormFieldChange('liveIntroVideo', e.target.value)}
                                        variant="outlined"
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            '& fieldset': {
                                              borderColor: '#e0e0e0',
                                              borderWidth: '1.5px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: '#2196f3',
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: '#2196f3',
                                              borderWidth: '2px'
                                            }
                                          },
                                          '& .MuiInputBase-input': {
                                            padding: '10px 14px',
                                            fontWeight: '500',
                                            fontSize: '14px'
                                          }
                                        }}
                                      />
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="body2" color="text.secondary">
                                          OR
                                        </Typography>
                                        <input
                                          type="file"
                                          accept="video/*"
                                          style={{ display: 'none' }}
                                          id={`liveIntroVideo-upload`}
                                          onChange={(e) => handleFileInputChange(e, 'liveIntroVideo')}
                                        />
                                        <label htmlFor={`liveIntroVideo-upload`}>
                                          <Button
                                            component="span"
                                            variant="outlined"
                                            size="small"
                                            startIcon={<CloudUploadIcon />}
                                            sx={{ minWidth: 100 }}
                                          >
                                            Select File
                                          </Button>
                                        </label>
                                        {(editFormData.liveIntroVideo || selectedFiles.liveIntroVideo) && (
                                          <IconButton
                                            size="small"
                                            onClick={() => clearFileSelection('liveIntroVideo')}
                                            sx={{ color: 'error.main' }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </Box>
                                      {(editFormData.liveIntroVideo || filePreviews.liveIntroVideo) && (
                                        <video
                                          src={filePreviews.liveIntroVideo || editFormData.liveIntroVideo}
                                          style={{
                                            width: "100%",
                                            height: 80,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #ddd",
                                          }}
                                          controls
                                          muted
                                          onError={(e) => {
                                            e.target.style.display = "none";
                                          }}
                                        />
                                      )}
                                      {selectedFiles.liveIntroVideo && (
                                        <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
                                          Selected: {selectedFiles.liveIntroVideo.name} (Will upload on save)
                                        </Typography>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <Typography
                            variant="h6"
                            color="primary"
                            fontWeight={600}
                            gutterBottom
                          >
                            Business Assets
                          </Typography>
                          <Stack spacing={3}>
                            <Box textAlign="center">
                              <Typography
                                variant="subtitle1"
                                fontWeight={600}
                                sx={{ mb: 1 }}
                              >
                                Business Document
                              </Typography>
                              {!isEditMode ? (
                                biz.businessDocument ? (
                                  <Box
                                    sx={{
                                      p: 1,
                                      border: "2px solid #e3f2fd",
                                      borderRadius: 2,
                                      bgcolor: "#fafafa",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                    onClick={() => {
                                      setFullSizePreview(!fullSizePreview);
                                      setImageUrl(biz?.businessDocument);
                                    }}
                                  >
                                    <img
                                      src={biz.businessDocument}
                                      alt="Document"
                                      style={{
                                        width: "100%",
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: 120,
                                      bgcolor: "#f5f5f5",
                                      borderRadius: 2,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#aaa",
                                      border: "1px dashed #ccc",
                                    }}
                                  >
                                    No Document
                                  </Box>
                                )
                              ) : (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Business Document URL"
                                    value={editFormData.businessDocument}
                                    onChange={(e) => handleFormFieldChange('businessDocument', e.target.value)}
                                    variant="outlined"
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        '& fieldset': {
                                          borderColor: '#e0e0e0',
                                          borderWidth: '1.5px'
                                        },
                                        '&:hover fieldset': {
                                          borderColor: '#2196f3',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: '#2196f3',
                                          borderWidth: '2px'
                                        }
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px 14px',
                                        fontWeight: '500',
                                        fontSize: '14px'
                                      }
                                    }}
                                  />
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      OR
                                    </Typography>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      style={{ display: 'none' }}
                                      id={`businessDocument-upload`}
                                      onChange={(e) => handleFileInputChange(e, 'businessDocument')}
                                    />
                                    <label htmlFor={`businessDocument-upload`}>
                                      <Button
                                        component="span"
                                        variant="outlined"
                                        size="small"
                                        startIcon={<CloudUploadIcon />}
                                        sx={{ minWidth: 100 }}
                                      >
                                        Select File
                                      </Button>
                                    </label>
                                    {(editFormData.businessDocument || selectedFiles.businessDocument) && (
                                      <IconButton
                                        size="small"
                                        onClick={() => clearFileSelection('businessDocument')}
                                        sx={{ color: 'error.main' }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </Box>
                                  {(editFormData.businessDocument || filePreviews.businessDocument) && (
                                    <img
                                      src={filePreviews.businessDocument || editFormData.businessDocument}
                                      alt="Document Preview"
                                      style={{
                                        width: "100%",
                                        height: 80,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                        border: "1px solid #ddd",
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                  )}
                                  {selectedFiles.businessDocument && (
                                    <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
                                      Selected: {selectedFiles.businessDocument.name} (Will upload on save)
                                    </Typography>
                                  )}
                                </Box>
                              )}
                            </Box>

                            <Box textAlign="center">
                              <Typography
                                variant="subtitle1"
                                fontWeight={600}
                                sx={{ mb: 1 }}
                              >
                                Business Logo
                              </Typography>
                              {!isEditMode ? (
                                biz.businessLogo ? (
                                  <Box
                                    sx={{
                                      p: 1,
                                      border: "2px solid #e8f5e8",
                                      borderRadius: 2,
                                      bgcolor: "#fafafa",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                    onClick={() => {
                                      setFullSizePreview(!fullSizePreview);
                                      setImageUrl(biz?.businessLogo);
                                    }}
                                  >
                                    <img
                                      src={biz.businessLogo}
                                      alt="Logo"
                                      style={{
                                        width: "100%",
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: 120,
                                      bgcolor: "#f5f5f5",
                                      borderRadius: 2,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#aaa",
                                      border: "1px dashed #ccc",
                                    }}
                                  >
                                    No Logo
                                  </Box>
                                )
                              ) : (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Business Logo URL"
                                    value={editFormData.businessLogo}
                                    onChange={(e) => handleFormFieldChange('businessLogo', e.target.value)}
                                    variant="outlined"
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        '& fieldset': {
                                          borderColor: '#e0e0e0',
                                          borderWidth: '1.5px'
                                        },
                                        '&:hover fieldset': {
                                          borderColor: '#2196f3',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: '#2196f3',
                                          borderWidth: '2px'
                                        }
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px 14px',
                                        fontWeight: '500',
                                        fontSize: '14px'
                                      }
                                    }}
                                  />
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      OR
                                    </Typography>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      style={{ display: 'none' }}
                                      id={`businessLogo-upload`}
                                      onChange={(e) => handleFileInputChange(e, 'businessLogo')}
                                    />
                                    <label htmlFor={`businessLogo-upload`}>
                                      <Button
                                        component="span"
                                        variant="outlined"
                                        size="small"
                                        startIcon={<CloudUploadIcon />}
                                        sx={{ minWidth: 100 }}
                                      >
                                        Select File
                                      </Button>
                                    </label>
                                    {(editFormData.businessLogo || selectedFiles.businessLogo) && (
                                      <IconButton
                                        size="small"
                                        onClick={() => clearFileSelection('businessLogo')}
                                        sx={{ color: 'error.main' }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </Box>
                                  {(editFormData.businessLogo || filePreviews.businessLogo) && (
                                    <img
                                      src={filePreviews.businessLogo || editFormData.businessLogo}
                                      alt="Logo Preview"
                                      style={{
                                        width: "100%",
                                        height: 80,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                        border: "1px solid #ddd",
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                  )}
                                  {selectedFiles.businessLogo && (
                                    <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
                                      Selected: {selectedFiles.businessLogo.name} (Will upload on save)
                                    </Typography>
                                  )}
                                </Box>
                              )}
                            </Box>

                            <Box textAlign="center">
                              <Typography
                                variant="subtitle1"
                                fontWeight={600}
                                sx={{ mb: 1 }}
                              >
                                Business Banner
                              </Typography>
                              {!isEditMode ? (
                                biz.businessBanner ? (
                                  <Box
                                    sx={{
                                      p: 1,
                                      border: "2px solid #fff3e0",
                                      borderRadius: 2,
                                      bgcolor: "#fafafa",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease",
                                      "&:hover": {
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                    onClick={() => {
                                      setFullSizePreview(!fullSizePreview);
                                      setImageUrl(biz?.businessBanner);
                                    }}
                                  >
                                    <img
                                      src={biz.businessBanner}
                                      alt="Banner"
                                      style={{
                                        width: "100%",
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: 120,
                                      bgcolor: "#f5f5f5",
                                      borderRadius: 2,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#aaa",
                                      border: "1px dashed #ccc",
                                    }}
                                  >
                                    No Banner
                                  </Box>
                                )
                              ) : (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Business Banner URL"
                                    value={editFormData.businessBanner}
                                    onChange={(e) => handleFormFieldChange('businessBanner', e.target.value)}
                                    variant="outlined"
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        '& fieldset': {
                                          borderColor: '#e0e0e0',
                                          borderWidth: '1.5px'
                                        },
                                        '&:hover fieldset': {
                                          borderColor: '#2196f3',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: '#2196f3',
                                          borderWidth: '2px'
                                        }
                                      },
                                      '& .MuiInputBase-input': {
                                        padding: '10px 14px',
                                        fontWeight: '500',
                                        fontSize: '14px'
                                      }
                                    }}
                                  />
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      OR
                                    </Typography>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      style={{ display: 'none' }}
                                      id={`businessBanner-upload`}
                                      onChange={(e) => handleFileInputChange(e, 'businessBanner')}
                                    />
                                    <label htmlFor={`businessBanner-upload`}>
                                      <Button
                                        component="span"
                                        variant="outlined"
                                        size="small"
                                        startIcon={<CloudUploadIcon />}
                                        sx={{ minWidth: 100 }}
                                      >
                                        Select File
                                      </Button>
                                    </label>
                                    {(editFormData.businessBanner || selectedFiles.businessBanner) && (
                                      <IconButton
                                        size="small"
                                        onClick={() => clearFileSelection('businessBanner')}
                                        sx={{ color: 'error.main' }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </Box>
                                  {(editFormData.businessBanner || filePreviews.businessBanner) && (
                                    <img
                                      src={filePreviews.businessBanner || editFormData.businessBanner}
                                      alt="Banner Preview"
                                      style={{
                                        width: "100%",
                                        height: 80,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                        border: "1px solid #ddd",
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                  )}
                                  {selectedFiles.businessBanner && (
                                    <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
                                      Selected: {selectedFiles.businessBanner.name} (Will upload on save)
                                    </Typography>
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            )
          )}

          {/* Modal for rejection reason */}
          <Modal
            open={showRejectModal}
            onClose={() => setShowRejectModal(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
          >
            <Fade in={showRejectModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6" mb={2}>
                  Reason for Rejection
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <textarea
                    placeholder="Enter reason for rejection..."
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    style={{
                      width: "100%",
                      minHeight: "120px",
                      padding: "12px",
                      fontSize: "16px",
                      fontFamily: "inherit",
                      border: reasonError
                        ? "2px solid #d32f2f"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      outline: "none",
                      resize: "vertical",
                      boxSizing: "border-box",
                      backgroundColor: "#fff",
                      color: "#333",
                      lineHeight: "1.4",
                    }}
                  />
                  {reasonError && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 1, display: "block" }}
                    >
                      Reason is required
                    </Typography>
                  )}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="flex-end"
                  mt={3}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={updateStatus}
                  >
                    Submit
                  </Button>
                </Stack>
              </Box>
            </Fade>
          </Modal>

          <FullImageView
            src={imageUrl}
            show={fullSizePreview}
            onHide={() => setFullSizePreview(false)}
          />
        </Box>
      </div>
    </>
  );
};

export default React.memo(ViewBusinessDetails);
